import { __decorate } from "tslib";
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Observer from '@slickdeals/durango/dist/javascript/observers/observer';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import DataLayer from '@slickdeals/blueprint-twig/javascript/utilities/dataLayer';
import { name as blueshiftName } from './blueshift';
import BlueshiftStats from './blueshiftStats';
/** The name of the module */
export const name = 'BlueshiftObserver';
/** Dependencies for this module */
export const dependencies = Object.assign({}, Injector.createDependency(blueshiftName, InjectorScope.Singleton));
let BlueshiftObserver = class BlueshiftObserver extends Observer {
    /**
       * Create a BlueshiftObserver instance
       *
       * @param blueshift Blueshift instance
       */
    constructor(blueshift) {
        super();
        this.blueshift = blueshift;
        this.blueshiftStats = new BlueshiftStats();
    }
    /**
       * Observe an observable with a callback to be executed when triggered by the provided observable
       *
       * @param observable Observable instance to be observed
       * @param eventName Optional event name to filter by
       */
    observe(observable, eventName = '') {
        this.registerCallback(this.track.bind(this), observable, eventName);
    }
    registerCallback(callback, observable, eventName = '') {
        super.registerCallback(callback, observable, eventName);
    }
    /**
       * Send an event for tracking through Blueshift API
       *
       * @param eventName Name of the event to be tracked
       * @param data Custom data to track along with the event name
       */
    track(data, eventName) {
        if (!eventName.length) {
            Logger.error('An event name is required for blueshift.track()', true);
            return;
        }
        DataLayer.get('visitor').then(visitor => {
            const { userId } = visitor;
            const eventData = Object.assign({}, data); // eslint-disable-line @typescript-eslint/no-explicit-any
            if (userId) {
                eventData.customer_id = userId;
            }
            if (eventData.threadid) {
                eventData.product_id = eventData.threadid;
            }
            this.blueshift.track(eventName, eventData);
            this.blueshiftStats.trackEventStats(eventName);
        });
    }
};
BlueshiftObserver = __decorate([
    injectable(name)
], BlueshiftObserver);
export default BlueshiftObserver;
